import abiJson from "./abi.json";

export const address = "0x1ea6f5382545faf382fd0a39dc962e2a8ec5ddd9";

export const abi = abiJson;
